import $ from 'jquery';
import debounce from 'debounce';
import breakpoints, { keys } from './breakpoints';

export default () => {
  const paragraph = $('.paragraph--type--partners-list');
  const container = paragraph.find('.view-content');

  container
    .addClass('owl-carousel owl-theme')
    .owlCarousel({
      rewind: false,
      autoWidth: true,
      loop: true,
      center: true,
      dots: false,
      autoplay: true,
      autoplayHoverPause: true,
      responsive: {
        '0': {
          margin: 15
        },
        '768': {
          margin: 30
        },
      }
    });
}
